import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ActionServiceContainerComponent} from './action-service-container.component';
import {LoadingModule} from "../../../../components/common/loading/loading.module";
import {ErrorTextModule} from "../error-text/error-text.module";

@NgModule({
    imports: [
        CommonModule,
        LoadingModule,
        ErrorTextModule,
    ],
    declarations: [
        ActionServiceContainerComponent
    ],
    exports: [
        ActionServiceContainerComponent
    ],
})
export class ActionServiceContainerModule {
}
